import { Component, OnInit } from '@angular/core';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent, DataBindingDirective } from '@progress/kendo-angular-grid';
import { GridSettings } from '../../../../../core/common';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { LanguageTranslationService } from '../../../../../core/services/language-translation.service';
import { PaymentService } from '../../../../../core/services/payment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { Location } from '@angular/common';
import { NotifyType } from '../../../../../core/enums/NotifyType';
import { IInvoiceInquiry, PaymentComment } from '../../../../../core/models';
import { Subject } from 'rxjs';
import { UserService } from '../../../../../core/services/user.service';
import { DomSanitizer, SafeResourceUrl, } from '@angular/platform-browser';
import { ActionsLayout } from '@progress/kendo-angular-dialog';


@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss']
})
export class ReviewComponent implements OnInit {

  trackerId: string;
  maxReasonLength: Number = 200;
  paymentInProgress: boolean = false;
  ccPaymentInProgress: boolean = false;
  constructor(private paymentService: PaymentService,
    private languageTranslationService: LanguageTranslationService,
    private router: Router,
    private appNotifyService: AppNotifyService,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer) {
    //get the trackerid from url
    this.activatedRoute.queryParamMap.subscribe(params => {
      this.trackerId = params.get('trackerID') || '';
    }
    );
  }
  pastTransactionDetails: any;
  openInvoices: any;
  paymentGridLoading: boolean = true;
  monthlyFreezeActive: boolean = false;
  showACHPaymentOption: boolean = false;
  showCreditCardPaymentOption: boolean = false;
  async ngOnInit() {
    await this.loadCCTranPrechecks();
    this.initPaymentOptions();
    this.paymentService.selectedInvoiceForPayment = [];
    this.calculateTotalPaymentAmount();
    // does The user has access to payment, if not then redirect to invoice inquiry screen
    this.paymentGridLoading = true;
    if (!this.userService.hasAccessToMakeInvoicePayment()) {
      this.router.navigate(['invoice-inquiry']);
    }


    //if there is a trackerid in the url and  cancel the last transaction and load the invoice list from the backend    
    if (this.trackerId && this.trackerId.length > 0) {
      //user cancellled payment from PNC portal     
      try {
        var lastTrnDtls = await this.paymentService.cancelLastTransaction(this.trackerId).toPromise();
      }
      catch (e) { }
    }

    //SKIP TO THIS LINE FOR NOW
    this.paymentInProgress = false;
    this.showCashModal = false;
    //user is coming from invoice inquiry and menu
    //load all open invoice for the customer
    try {
      this.openInvoices = await this.paymentService.fetchOpenInvoices().toPromise();
      this.paymentGridLoading = false;
    }
    catch (e) {
      this.paymentGridLoading = false;
    }


    //else if we dont have any selected invoice then redirect user to invoice inquiry screen
    //if (!(this.paymentService.selectedInvoiceForPayment &&
    //  this.paymentService.selectedInvoiceForPayment.length > 0)) {
    //  this.router.navigate(['invoice-inquiry']);
    //}
    this.loadPaymentReviewGrid(this.openInvoices);
    this.paymentGridLoading = false;

  }
  showCCBtn: boolean = false;
  ccTranMaxLimit: number = -1;
  async loadCCTranPrechecks() {
    try {
      let res = await this.paymentService.loadCCPrecheck().toPromise();
      if (res != null) {
        if (res.ccTranLimit != null && res.ccTranLimit > 0) {
          this.ccTranMaxLimit = res.ccTranLimit;
        }
        if (res.showCCTranSection) {
          this.showCCBtn = true;
        }
      }
    }
    catch (e) { }
  }

  initPaymentOptions() {
    this.showACHPaymentOption = this.userService.hasAccessToMakeACHInvoicePayment();
    this.showCreditCardPaymentOption = this.userService.hasAccessToMakeCreditCardInvoicePayment() && this.showCCBtn;
  }

  async refreshPage() {
    this.paymentInProgress = false;
    this.showCashModal = false;
    this.paymentGridLoading = true;
    //user is coming from invoice inquiry and menu
    //load all open invoice for the customer
    try {
      this.openInvoices = await this.paymentService.fetchOpenInvoices().toPromise();
      this.paymentGridLoading = false;
    }
    catch (e) {
      this.paymentGridLoading = false;
    }

    //else if we dont have any selected invoice then redirect user to invoice inquiry screen
    //if (!(this.paymentService.selectedInvoiceForPayment &&
    //  this.paymentService.selectedInvoiceForPayment.length > 0)) {
    //  this.router.navigate(['invoice-inquiry']);
    //}
    this.loadPaymentReviewGrid(this.openInvoices);
    this.paymentGridLoading = false;
    this.paymentService.selectedInvoiceForPayment = [];
    this.calculateTotalPaymentAmount();
  }

  //#region List of functionalities
  //Should be able to edit the amoount & add payment reason
  //there should be atleast 1 invoice in the list for payment
  //can delete the invoice from the list
  //#endregion

  selectedInvoiceForPayment: any;
  paymentReviewGridData: GridDataResult;
  async cancelLastTransaction(trackerId: string) {
    var lastTransactionDetails = await this.paymentService.cancelLastTransaction(trackerId).toPromise();
    //parse last transaction details and fill the invoice informations here
  }
  async proceedToACHPaymentGateway() {
    //handle exception accordingly
    var isValid: boolean = true;
    if (!this.paymentService.selectedInvoiceForPayment) {
      this.appNotifyService.notify(NotifyType.ERROR, 'Please select at least one invoice to pay!');
      return;
    }
    if (this.paymentService.selectedInvoiceForPayment.length == 0) {
      this.appNotifyService.notify(NotifyType.ERROR, 'Please select at least one invoice to pay!');
      return;
    }
    if (this.paymentService.selectedInvoiceForPayment.findIndex(o => o.payAmount > 1) < 0) {
      this.appNotifyService.notify(NotifyType.ERROR, 'Please select at least one invoice to pay!');
      return;
    }
    this.paymentService.selectedInvoiceForPayment.forEach((inv, index) => {
      if (inv.paymentReasonRequired && !inv.paymentReason && isValid) {
        this.appNotifyService.notify(NotifyType.ERROR, 'Please correct the errors before proceeding to payment');
        isValid = false;
      }
    })
    if (!isValid) return;
    try {
      this.paymentInProgress = true;
      var paymentResponse = await this.paymentService.initiateACHPayment().toPromise();
      if (paymentResponse.isError) {
        //show some error message to user
        this.ccPaymentInProgress = false;
        this.paymentInProgress = false;
        this.appNotifyService.notify(NotifyType.ERROR, paymentResponse.errorMsg);
        return;
      }
      if (paymentResponse.mode === 'ACH') {
        //go to PNC
        console.log('pnc redirect');
        this.paymentService.redirectToPNC(paymentResponse.achPayload, paymentResponse.actionUrl);
        //this.paymentInProgress = false;
      }
      else {
        //show confirmation to user
        this.showCashModal = true;
        this.paymentInProgress = false;
      }
    }
    catch (e) {
      console.log(e);
      //show some error message to user
      this.appNotifyService.notify(NotifyType.ERROR, 'Sorry an error occured. Please reload and try again!');
      this.paymentInProgress = false;
      return;
    }
  }


  goBack() {
    //this.location.back();
    this.paymentService.removeTrackerFromLocalStorage();
    this.router.navigate(['invoice-inquiry']);//pass optional data
  }



  //#region Grid State & Settings

  public paymentReviewGridState: State = {
    skip: 0,
    take: 1000,
    group: null,
    sort: [{
      field: 'dueDateAsDate',
      dir: 'asc'
    }],
    filter: {
      logic: 'and',
      filters: [{
        field: "paymentStatus", operator: "eq", value: 'OPEN'
      }]
    },
  };

  public paymentReviewGridSettings: GridSettings = {
    state: this.paymentReviewGridState,

    //gridData: process(this.paymentReviewGridData, this.paymentReviewGridState),
    columnsConfig: [{
      field: 'invoiceNumber',
      title: 'Invoice Number',
      filterable: false,
      //widthForPDF: 40,
      _width: 100,
    },
    {
      field: 'invoiceDateAsDate',
      title: 'Invoice Date',
      filterable: true,
      format: '{0:d}',
      _width: 230,
      //widthForPDF: 60
    },
    {
      field: 'dueDateAsDate',
      title: 'Due Date',
      _width: 230,
      filterable: true,
      //widthForPDF: 40
      format: '{0:d}',
      //_width: 130,
    },
    {
      field: 'type',
      title: 'Type',
      filterable: false,
      _width: 60,
    }, {
      field: 'poNumber',
      title: 'PO',
      filterable: false,
      //widthForPDF: 30
      _width: 70,
    }, {
      field: 'jobName',
      title: 'Job Name',
      _width: 120,
      filterable: false,
      //widthForPDF: 50
    }, {
      field: 'originalAmount',
      title: 'Original Amount',
      filterable: false,
      _width: 120,
      //widthForPDF: 50
    },
    {
      field: 'amountDue',
      title: 'Amount Due',
      _width: 120,
      filterable: false,
      //widthForPDF: 40
    },
    {
      field: 'payAmount',
      title: 'Payment Amount',
      _width: 120,
      filterable: false,
      //widthForPDF: 40
    },
    {
      field: 'paymentReason',
      title: 'Payment Reason',
      _width: 200,
      filterable: false,
      //widthForPDF: 50
    }, {
      field: 'paymentComments',
      title: '',
      _width: 200,
      filterable: false,
      //widthForPDF: 50
    }
    ]
  };

  //#endregion

  loadPaymentReviewGrid(data) {
    this.paymentReviewGridData = process(data, this.paymentReviewGridState);
    this.paymentReviewGridSettings.gridData = this.paymentReviewGridData;
  }
  //#region Grid Sort, Data page change events
  public paymentReviewGridDataStateChange(state: DataStateChangeEvent): void {
    this.paymentReviewGridState = state;
    this.loadPaymentReviewGrid(this.openInvoices);
  }
  public paymentReviewGridSortChange(sort): void {
    this.paymentReviewGridState.sort = sort;
    this.loadPaymentReviewGrid(this.openInvoices);
  }

  public paymentReviewGridPageChange({ skip, take }: PageChangeEvent): void {
    this.paymentReviewGridState.skip = skip;
    this.paymentReviewGridState.take = take;
    this.loadPaymentReviewGrid(this.openInvoices);
  }
  //#endergion
  //#region Grid Events
  handlePaymentAmountChange(event, dataItem: IInvoiceInquiry) {
    var amt: any = event;
    dataItem.paymentComments = dataItem.paymentComments.filter(x => x.type != this.paymentService.overOrUnderPaymentMsgType);
    if (amt == dataItem.calculatedAmountDue) {
      if (dataItem.discountAvailable > 0) {
        dataItem.paymentReasonRequired = true;
        dataItem.paymentReason = 'Discounted 1%';
      }
      else {
        dataItem.paymentReasonRequired = false;
      }
    }
    else {
      var overOrUnderPaymentText = 'You are paying a different amount than due amount($' + dataItem.calculatedAmountDue + '). Please enter a reason.';
      dataItem.paymentReasonRequired = true;
      dataItem.paymentReason = '';
      dataItem.paymentComments = [];
      dataItem.paymentComments.push({
        isError: true, message: overOrUnderPaymentText,
        type: this.paymentService.overOrUnderPaymentMsgType, show: true
      });
    }
    dataItem.payAmount = amt;
    this.calculateTotalPaymentAmount();
  }
  handlePaymentReasonEntered(event, dataItem: IInvoiceInquiry) {
    if (!dataItem.paymentComments) return;
    if (dataItem.paymentReasonRequired) {
      //payment reason enetered remove validation text
      dataItem.paymentReason = event;
      dataItem.paymentComments = dataItem.paymentComments.filter(x => x.type !== this.paymentService.overOrUnderPaymentMsgType)
      if (!(event && event.length > 0)) {
        var overOrUnderPaymentText = 'You are paying a different amount than due amount($' + dataItem.calculatedAmountDue + '). Please enter a reason.';
        dataItem.paymentReasonRequired = true;
        dataItem.paymentComments.push({
          isError: true, message: overOrUnderPaymentText,
          type: this.paymentService.overOrUnderPaymentMsgType, show: true
        });
      }
    }
    else {
      dataItem.paymentComments = dataItem.paymentComments.filter(x => x.type !== this.paymentService.overOrUnderPaymentMsgType)
    }
    dataItem.paymentReasonCharCounter = '' + event.length + '/' + this.maxReasonLength + '';
  }

  //#endregion
  toatlAmt: number = 0;
  totalInvoiceSelected: number = 0;
  calculateTotalPaymentAmount() {
    this.toatlAmt = 0;
    this.paymentService.selectedInvoiceForPayment.forEach((item, index) => {
      this.toatlAmt += item.payAmount;
    });
    this.toatlAmt = +this.toatlAmt.toFixed(2);
    this.totalInvoiceSelected = this.paymentService.selectedInvoiceForPayment.length;
  }

  selectAllInvoices: boolean = false;
  selectInvoiceForPayment(event, dataItem: IInvoiceInquiry) {
    if (event.target.checked) {
      dataItem.selectedForPayment = true;
      this.paymentService.addInvoiceForPayment(dataItem);
    }
    else {
      dataItem.selectedForPayment = false;
      this.paymentService.removeInvoiceFromPaymentList(dataItem);
    }
    this.calculateTotalPaymentAmount();
  }
  selectAllInvoiceForPayment(event) {
    let d = this.paymentReviewGridData;
    console.log('Grid data');
    console.log(d);
    if (event.target.checked) {
      for (var i = 0; i < d.data.length; i++) {
        d.data[i].selectedForPayment = true;
        this.paymentService.addInvoiceForPayment(d.data[i]);
      }
    }
    else {
      for (var i = 0; i < d.data.length; i++) {
        d.data[i].selectedForPayment = false;
        //this.paymentService.removeInvoiceFromPaymentList(d.data[i]);
      }
      this.paymentService.resetPaymentList();
    }

    this.calculateTotalPaymentAmount();
  }


  showCashModal: boolean = false;
  async closeCashPayModal() {
    this.showCashModal = false;
    await this.refreshPage();
    //refreh page
  }

  //#region Credit Card

  url: SafeResourceUrl;
  urlSafe: string;


  async proceedToCreditCardPaymentGateway() {
    this.showSurchargeDialog = false;
    this.paymentService.browserName = "";
    let isSafari = await this.isSafari();
    let winRef: any;
    if (isSafari) {
      if (this.toatlAmt >= 1) {
        this.paymentService.browserName = "safari";
        winRef = window.open();
      }
    }
    var isValid: boolean = this.isCreditCardTransactionValid();
    if (!isValid) return;
    try {
      this.paymentInProgress = false;
      this.ccPaymentInProgress = true;
      var paymentResponse = await this.paymentService.initiateCreditCardPayment().toPromise();
      if (paymentResponse.isError) {
        this.paymentInProgress = false;
        this.ccPaymentInProgress = false;
        this.appNotifyService.notify(NotifyType.ERROR, paymentResponse.errorMsg);
        return;
      }

      if (paymentResponse.mode == 'ManualProcessing') {
        this.paymentInProgress = false;
        this.ccPaymentInProgress = false;
        this.showCashModal = true;
        return;
      }

      this.paymentService.ccActionUrl = paymentResponse.actionUrl;
      this.paymentService.ccRequestId = paymentResponse.ccPayload.requestId;
      this.paymentService.ccTrackerId = paymentResponse.ccPayload.trackerId;
      localStorage.setItem("RequestId", paymentResponse.ccPayload.requestId);
      localStorage.setItem("trkId", paymentResponse.ccPayload.trackerId);

      ////#region Test Only Delete it
      //this.ccPaymentInProgress = false;
      //return;
      ////#endregion

      if (this.paymentService.browserName == 'safari') {
        winRef.location = paymentResponse.actionUrl;
        //window.open(paymentResponse.actionUrl, '_blank');
      } else {
        // localStorage.setItem("RequestId", paymentResponse.);
        this.router.navigate(['/invoice-inquiry/payment/creditcard']);
      }
      //console.log(this.url);
    }
    catch (e) {
      //console.log(e);
      this.appNotifyService.notify(NotifyType.ERROR, 'Sorry an error occured. Please reload and try again!');
      this.ccPaymentInProgress = false;
      return;
    }
  }

  async isSafari() {
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return isSafari;
  }

  isCreditCardTransactionValid() {
    var isValid: boolean = true;
    if (this.ccPaymentInProgress || this.paymentInProgress) {
      this.appNotifyService.notify(NotifyType.ERROR, 'Another payment is already in progress!');
      isValid = false;
      return isValid;
    };

    if (!this.paymentService.selectedInvoiceForPayment) {
      this.appNotifyService.notify(NotifyType.ERROR, 'Please select at least one invoice to pay!');
      isValid = false;
      return isValid;
    };
    if (this.paymentService.selectedInvoiceForPayment.length == 0) {
      this.appNotifyService.notify(NotifyType.ERROR, 'Please select at least one invoice to pay!');
      isValid = false;
      return isValid;
    };
    this.paymentService.selectedInvoiceForPayment.forEach((inv, index) => {
      if (inv.paymentReasonRequired && !inv.paymentReason && isValid) {
        this.appNotifyService.notify(NotifyType.ERROR, 'Please correct the errors before proceeding to payment');
        return isValid;
      }
    });
    return isValid;
  }
  showSurchargeDialog: boolean = false;
  public actionsLayout: ActionsLayout = "stretched";
  public layoutOptions: Array<string> = ["start", "center", "end", "stretched"];
  showSurchargeConfirmationBox() {
    if (this.isCreditCardTransactionValid) {
      this.showSurchargeDialog = true;
    }
  }
  closeSurchargeConfirmationBox() {
    this.showSurchargeDialog = false;
  }

  beginCCPayment() {
    if (this.paymentService.selectedInvoiceForPayment.findIndex(o => o.payAmount > 1) < 0) {
      this.appNotifyService.notify(NotifyType.ERROR, 'Please select at least one invoice to pay!');
      return;
    }
    if (this.ccTranMaxLimit > 1 && this.toatlAmt > this.ccTranMaxLimit) {
      this.openCCTranLimitModal();
      return;
    }
    this.showSurchargeConfirmationBox();
  }

  //#endregion
  //#region CC Precheck
  showCCTranLimitModal: boolean = false;
  openCCTranLimitModal() {
    this.showCCTranLimitModal = true;
  }
  closeCCTranLimitModal() {
    this.showCCTranLimitModal = false;
  }
  //#endregion 
}
